module.exports = __webpack_public_path__ + "img/accumulator-discharge-animation.09bedfc5.png";